package ru.it_mozaika.sender.js.application.components.catalog

import mui.material.*
import react.FC
import react.Props

external interface IdsCopyDialogProps: Props{
    var isOpen: Boolean
    var onClose: () -> Unit
    var ids: List<String>
}

val IdsCopyDialog = FC<IdsCopyDialogProps> {props ->
    Dialog{
        this.open = props.isOpen
        DialogTitle{
                + "Скопированны следующие ID:"
        }
        DialogContent{
            + props.ids.joinToString(",")
        }
        DialogActions{
            Button{
                +  "Назад"
                color = ButtonColor.secondary
                variant = ButtonVariant.outlined
                onClick = {
                    props.onClose()
                }
            }
        }
    }
}